import { useEffect, useState } from 'react';

import { ApiGet } from '../../services/apiService';
import {
  ambienteSelect,
  areaSelect,
  getDisplayedPageNumbers,
  questionarioAreaPost
} from './functions';
import { Cadastro } from './questionarioArea/Cadastro';
import { Grid } from './questionarioArea/Grid';

export const QuestionarioArea = (props) => {
  const [activeTab, setActiveTab] = useState(1);
  const [dataGrid, setDataGrid] = useState([]);
  const [insertOrUpdate, setInsertOrUpdate] = useState(null);
  const [data, setData] = useState({
    qar_codusu: localStorage.getItem('sessionUsuario')
  });
  const [optionsArea, setOptionsArea] = useState([]);
  const [optionsQuestionario, setOptionsQuestionario] = useState([]);

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const itemsPerPage = 10;
  const offset = currentPage * itemsPerPage;

  const displayedPageNumbers = getDisplayedPageNumbers(currentPage, pageCount);

  const handleSearch = async () => {
    try {
      const response = await ApiGet(
        '/v1/selectTabela/',
        {
          from: 'questionario_area',
          select: [
            '*',
            '(SELECT are_descri from tab_area where are_codare = qar_codare) as are_descri',
            '(SELECT que_descri from questionario where que_seqque = qar_seqque) as que_descri'
          ],
          order: {
            column: 'are_descri, que_descri',
            isAscending: true
          }
        },
        localStorage.getItem('sessionToken')
      );
      setDataGrid(response.data.dados.rows);
      setOptionsArea(await areaSelect());
      setOptionsQuestionario(await ambienteSelect({}));
    } catch (err) {
      console.log(err);
    }
  };

  const handleSort = (order, direction) => {
    let multiplier = direction === 'asc' ? 1 : -1;
    switch (order) {
      case 'qar_codare':
        setDataGrid(
          [...dataGrid].sort(
            (a, b) => multiplier * a.qar_codare.localeCompare(b.qar_codare)
          )
        );
        break;
      case 'are_descri':
        setDataGrid(
          [...dataGrid].sort(
            (a, b) => multiplier * a.are_descri.localeCompare(b.are_descri)
          )
        );
        break;
      case 'qar_seqque':
        setDataGrid(
          [...dataGrid].sort(
            (a, b) => multiplier * a.qar_seqque.localeCompare(b.qar_seqque)
          )
        );
        break;
      case 'que_descri':
        setDataGrid(
          [...dataGrid].sort(
            (a, b) => multiplier * a.que_descri.localeCompare(b.que_descri)
          )
        );
        break;
      default:
        setDataGrid([...dataGrid]);
        break;
    }
  };

  useEffect(() => {
    if (props.activeTab === 7) {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeTab]);

  useEffect(() => {
    if (dataGrid != undefined) {
      setFilteredData(dataGrid.slice(offset, offset + itemsPerPage));
      setPageCount(Math.ceil(dataGrid.length / itemsPerPage));
      setCurrentPage(0);
      setSelectedRow(null);
    }
    // eslint-disable-next-line
  }, [dataGrid]);

  useEffect(() => {
    if (dataGrid !== undefined) {
      setFilteredData(dataGrid.slice(offset, offset + itemsPerPage));
    }
    // eslint-disable-next-line
  }, [currentPage]);

  useEffect(() => {
    if (props.tabInsert === 7) {
      const data = new Date();
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const dia = String(data.getDate()).padStart(2, '0');

      const hora = data.getHours();
      const minuto = String(data.getMinutes()).padStart(2, '0');
      const segundo = String(data.getSeconds()).padStart(2, '0');

      setData({
        ...data,
        qar_codusu: localStorage.getItem('sessionUsuario'),
        qar_datincl: `${ano}-${mes}-${dia}`,
        qar_horincl: `${hora}:${minuto}:${segundo}`
      });

      props.setTitle(`${props.title} - Inserir`);
      setInsertOrUpdate('insert');
      props.setNvAcesso('insert');
      setActiveTab(2);
      props.setTabReturn(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.tabInsert]);

  useEffect(() => {
    if (props.tabReturn === 0) {
      setActiveTab(1);
      setData({ usuario: localStorage.getItem('sessionUsuario') });
    }
  }, [props.tabReturn]);

  useEffect(() => {
    if (props.tabUpdate === 7) {
      const fetch = async () => {
        const body = {
          questionarioID: data.qar_seqque,
          areaID: data.qar_codare,
          usuario: data.qar_codusu
        };

        if (insertOrUpdate === 'insert') await questionarioAreaPost(body);

        const texto = props.title.split(' - ');
        props.setTitle(texto[0]);

        setData({
          qar_codusu: localStorage.getItem('sessionUsuario')
        });

        await handleSearch();

        setActiveTab(1);
        props.setTabReturn(0);
        props.setTabUpdate(0);
        props.setTabInsert(0);
      };
      fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.tabUpdate]);

  return (
    <div>
      <div>
        <div className="nav nav-tabs">
          <p
            className={`nav-link ${
              activeTab === 1 ? 'text-primary active' : 'text-dark'
            }`}
            onClick={() => setActiveTab(1)}
            style={{ display: 'none' }}
          >
            {/* Tabela */}
          </p>
          <p
            className={`nav-link ${
              activeTab === 2 ? 'text-primary active' : 'text-dark'
            }`}
            onClick={() => setActiveTab(2)}
            style={{ display: 'none' }}
          >
            {/* Insert */}
          </p>
        </div>

        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab === 1 ? 'active' : ''}`}
            id="tab1"
          >
            <Grid
              filteredData={filteredData}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageCount={pageCount}
              displayedPageNumbers={displayedPageNumbers}
              setActiveTab={setActiveTab}
              data={data}
              setData={setData}
              dataGrid={dataGrid}
              setInsertOrUpdate={setInsertOrUpdate}
              handleSearch={handleSearch}
              tamTexto={props.tamTexto}
              tamSubTexto={props.tamSubTexto}
              setTabReturn={props.setTabReturn}
              setNvAcesso={props.setNvAcesso}
              handleSort={handleSort}
              setTitle={props.setTitle}
              title={props.title}
            />
          </div>
          <div
            className={`tab-pane ${activeTab === 2 ? 'active' : ''}`}
            id="tab2"
          >
            <Cadastro
              data={data}
              setData={setData}
              insertOrUpdate={insertOrUpdate}
              optionsArea={optionsArea}
              optionsQuestionario={optionsQuestionario}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
